module.exports = __webpack_public_path__ + "img/ele4.f42871cd.svg";